import { useSubmit } from "@certn/api";
import { showToast, TextInputFormikField } from "@certn/cascadia-react";
import { Formik } from "formik";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { object, string, number } from "yup";

import { CredentialTemplatePageLayout } from "./CredentialTemplatePageLayout";
import { initialCredentialTemplateValues } from "./CredentialTemplatesContext";
import { CredentialDetails } from "../components/CredentialDetails";
import { CustomInstructionsFormSection } from "../../templates/CustomInstructionsFormSection";
import { CREDENTIAL_DEFAULT_INSTRUCTIONS } from "../../templates/customInstructionsConstants";
import { customInstructionsSchemaField } from "../../templates/customInstructionsValidation";

export function CredentialTemplatesPage() {
  const navigate = useNavigate();

  const { submit } = useSubmit(
    "/api/internal/client-portal/check-arguments-templates/credential-verification/create/",
    {
      throwErrors: true,
      showToastOnError: true,
      onSuccess: () => {
        showToast(t("Credential verification template has been created."), {
          type: "success",
        });
        navigate("/settings/credential-verification-templates");
      },
    }
  );

  const schema = object().shape({
    name: string().required().label(t("Template name")),
    check_arguments: object().shape({
      minimum: number().required().min(1).max(10).label(t("Minimum")),
      maximum: number().required().min(1).max(10).label(t("Maximum")),
      custom_instructions: customInstructionsSchemaField(),
    }),
  });

  return (
    <Formik
      initialValues={initialCredentialTemplateValues}
      validationSchema={schema}
      onSubmit={(values) => submit(values)}
    >
      {({ handleSubmit, isSubmitting, values }) => {
        return (
          <CredentialTemplatePageLayout
            onComplete={handleSubmit}
            submitting={isSubmitting}
          >
            <TextInputFormikField
              name="name"
              testID="template-name"
              isRequired
              label={t("Template name")}
              description={t(
                "Used internally to identify the template. The applicant will not see this."
              )}
            />
            <CredentialDetails checkArguments={values.check_arguments} />
            <CustomInstructionsFormSection
              fieldName="check_arguments.custom_instructions"
              defaultInstructionsPlaceholder={CREDENTIAL_DEFAULT_INSTRUCTIONS()}
            />
          </CredentialTemplatePageLayout>
        );
      }}
    </Formik>
  );
}
